import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    inject,
    OnInit,
    PLATFORM_ID,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { SocialMediaComponent } from '@shared/social-media/social-media.component';
import { isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { InputComponent } from '@shared/input/input.component';
import { ConnectWithOurTeamService } from '@content/contact-us/connect-with-our-team/connect-with-our-team.service';
import { ReactiveFormsModule } from '@angular/forms';
import { LocalesComponent } from '@shared/location/locales/locales.component';
import { TitleAndSubtitleComponent } from '@shared/title-and-subtitle/title-and-subtitle';
import { CountriesDropdownComponent } from '@content/contact-us/connect-with-our-team/countries-dropdown/countries-dropdown.component';
import { countries } from '@company-id-shared/constants/constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { IpInfoService } from '@shared/ip-info/ip-info.service';

@Component({
    selector: 'companyid-connect-with-our-team',
    imports: [
        ContentWrapperComponent,
        SocialMediaComponent,
        NgOptimizedImage,
        AssetPipe,
        InputComponent,
        ReactiveFormsModule,
        LocalesComponent,
        CountriesDropdownComponent,
        TitleAndSubtitleComponent,
    ],
    providers: [ConnectWithOurTeamService],
    templateUrl: './connect-with-our-team.component.html',
    styleUrl: './connect-with-our-team.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectWithOurTeamComponent implements OnInit {
    public mask = signal<string>('');

    private readonly ipInfoService = inject(IpInfoService);
    private readonly connectWithOurTeamService = inject(ConnectWithOurTeamService);
    private readonly destroyRef = inject(DestroyRef);
    private readonly platformId = inject<string>(PLATFORM_ID);
    public readonly form = this.connectWithOurTeamService.form;

    public ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.ipInfoService
                .getCountryCode()
                .pipe(
                    tap((countryCode) => {
                        const currentCounty = countries.find((c) => c.countryCode === countryCode);
                        this.form.patchValue({ code: currentCounty?.dial_code ?? '' });
                    }),
                )
                .subscribe();
        }
        this.form.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            const { code } = this.form.value;
            if (code) {
                this.mask.set(countries.find((country) => country.dial_code.includes(code))?.mask ?? '');
            }
        });
    }

    public sendEmail(): void {
        this.connectWithOurTeamService.sendContactForm();
    }
}
